import { useFormContext, useWatch } from 'react-hook-form';
import { SignInputSchool, SignInputSchoolManual } from '@/module/auth/sign-up';
import { type TeacherEditFormData } from '../schema';
import { CommonEditForm } from './CommonEditForm';
import { PhoneSectionInForm } from './PhoneSectionInForm';
export const TeacherEditForm = () => {
  const {
    control
  } = useFormContext<TeacherEditFormData>();
  const countryCode = useWatch({
    control,
    name: 'countryCode'
  });
  const isKR = countryCode === 'KR';
  return <>
      <CommonEditForm data-sentry-element="CommonEditForm" data-sentry-source-file="TeacherEditForm.tsx" />
      {isKR ? <SignInputSchool /> : <SignInputSchoolManual />}
      <PhoneSectionInForm type="teacher" data-sentry-element="PhoneSectionInForm" data-sentry-source-file="TeacherEditForm.tsx" />
    </>;
};